import { BreadcrumbsProps } from "@insite/mobius/Breadcrumbs";
import { LinkProps } from "@insite/mobius/Link";
import useStructuredData from "@store/Framework/Common/Hooks/StructuredData/useStructuredData";
import { BreadcrumbList, ListItem } from "@store/Framework/Schemas/structuredData";
import { FC, useEffect, useState } from "react";

const BreadcrumbsStructuredData: FC<BreadcrumbsProps> = ({ links }) => {
    const [data, setData] = useState<BreadcrumbList>();

    useEffect(() => {
        if (!links || links.length === 0 || !window?.location) {
            return;
        }

        setData({
            "@type": "BreadcrumbList",
            itemListElement: getItemListElements(links, window.location.origin, window.location.href),
        });
    }, [links]);

    useStructuredData(data);

    return null;
};

export const getItemListElements = (links: LinkProps[], baseUrl: string, currentUrl: string) => {
    const linksData: any[] = [];

    if (!baseUrl || !currentUrl) {
        return linksData;
    }

    for (let i = 0; i < links.length; i++) {
        linksData.push({
            "@type": "any",
            item: {
                "@id": links[i].href ? baseUrl + links[i].href : currentUrl,
                name: links[i].children?.toString(),
            },
            position: i + 1,
        });
    }

    return linksData;
};

export default BreadcrumbsStructuredData;
